<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Bill Numbers"
            :data="editedItem"
            :valueData="editedItem.bill_num"
            noGutters
          />
          <data-detail-row
            label="Aggregator Name"
            :data="editedItem"
            :valueData="editedItem.aggregator_name"
            noGutters
          />
          <data-detail-row
            label="Merchant Name"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="MID"
            :data="editedItem"
            :valueData="editedItem.mid"
            noGutters
          />
          <data-detail-row
            label="Merchant PAN"
            :data="editedItem"
            :valueData="editedItem.mpan"
            noGutters
          />
          <data-detail-row
            label="Reff ID"
            :data="editedItem"
            :valueData="editedItem.rrn"
            noGutters
          />
          <data-detail-row
            label="QR Method"
            :data="editedItem"
            :valueData="editedItem.qr_method"
            noGutters
          />
          <data-detail-row
            v-if="shouldShowAmountType"
            label="Amount Type"
            :data="editedItem"
            :valueData="editedItem.amount_type"
            noGutters
          />
          <data-detail-row
            label="QR Type"
            :data="editedItem"
            :valueData="editedItem.qr_type"
            noGutters
          />
          <data-detail-row
            label="Transaction Type"
            :data="editedItem"
            :valueData="editedItem.trx_type"
            noGutters
          />
          <data-detail-row
            label="Issuer Name"
            :data="editedItem"
            :valueData="editedItem.issuer_name"
            noGutters
          />
          <data-detail-row
            label="Customer PAN"
            :data="editedItem"
            :valueData="editedItem.customer_pan"
            noGutters
          />
          <data-detail-row
            label="Source of Fund"
            :data="editedItem"
            :valueData="editedItem.payment_method"
            noGutters
          />
          <data-detail-row
            label="Customer Name"
            :data="editedItem"
            :valueData="editedItem.customer_name"
            noGutters
          />
          <data-detail-row
            label="Payment Type"
            :data="editedItem"
            :valueData="editedItem.payment_type"
            noGutters
          />
          <data-detail-row
            label="Acquirer Name"
            :data="editedItem"
            :valueData="editedItem.payment_channel"
            noGutters
          />
          <data-detail-row
            label="Amount"
            :data="editedItem"
            :valueData="editedItem.amount"
            noGutters
          />
          <data-detail-row
            label="MDR"
            :data="editedItem"
            :valueData="editedItem.amount_mdr"
            noGutters
          />
          <data-detail-row
            label="Net Amount"
            :data="editedItem"
            :valueData="editedItem.net_amount"
            noGutters
          />
          <data-detail-row
            label="Amount Fee"
            :data="editedItem"
            :valueData="editedItem.amount_fee"
            noGutters
          />
          <data-detail-row
            label="Transaction Date"
            :data="editedItem"
            :valueData="editedItem.trx_datetime"
            noGutters
          />
          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            label="Settlement Status"
            :data="editedItem"
            :valueData="editedItem.settlement_status"
            noGutters
          />
          <data-detail-row
            label="Settlement Date"
            :data="editedItem"
            :valueData="editedItem.settlement_datetime"
            noGutters
          />
          <data-detail-row
            label="Additional Data"
            :data="editedItem"
            :valueData="editedItem.additional_data"
            noGutters
          />
          <data-detail-row
            label="Promo Code"
            :data="editedItem"
            :valueData="editedItem.promo_code"
            noGutters
          />
          <data-detail-row
            label="Switcher Name"
            :data="editedItem"
            :valueData="editedItem.switcher_name"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  components: { DataDetailRow: () => import('../detail/DataDetailRow.vue') },
  props: ['editedItem'],
  computed: {
    shouldShowAmountType() {
      return this.editedItem.product_indicator !== 'N001' && this.editedItem.product_indicator !== 'N005';
    }
  },
  data: () => ({
    dialogMerchant: false,
  }),
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
